export const userManagementConstant = {
  //get
  GET_USER_LIST_REQUEST: "GET_USER_LIST_REQUEST",
  GET_USER_LIST_SUCCESS: "GET_USER_LIST_SUCCESS",
  GET_USER_LIST_FAILURE: "GET_USER_LIST_FAILURE",


  GET_SWAP_LIST_REQUEST: "GET_SWAP_LIST_REQUEST",
  GET_SWAP_LIST_SUCCESS: "GET_SWAP_LIST_SUCCESS",
  GET_SWAP_LIST_FAILURE: "GET_SWAP_LIST_FAILURE",

  GET_ORDER_HISTORY_LIST_REQUEST: "GET_ORDER_HISTORY_LIST_REQUEST",
  GET_ORDER_HISTORY_LIST_SUCCESS: "GET_ORDER_HISTORY_LIST_SUCCESS",
  GET_ORDER_HISTORY_LIST_FAILURE: "GET_ORDER_HISTORY_LIST_FAILURE",



  GET_LOGIN_HISTORY_LIST_REQUEST: "GET_LOGIN_HISTORY_LIST_REQUEST",
  GET_LOGIN_HISTORY_LIST_SUCCESS: "GET_LOGIN_HISTORY_LIST_SUCCESS",
  GET_LOGIN_HISTORY_LIST_FAILURE: "GET_LOGIN_HISTORY_LIST_FAILURE",


  GET_WEB_STORE_LIST_REQUEST: "GET_WEB_STORE_LIST_REQUEST",
  GET_WEB_STORE_LIST_SUCCESS: "GET_WEB_STORE_LIST_SUCCESS",
  GET_WEB_STORE_LIST_FAILURE: "GET_WEB_STORE_LIST_FAILURE",



  GET_TRANSACTION_LIST_BY_USERID_REQUEST: "GET_TRANSACTION_LIST_BY_USERID_REQUEST",
  GET_TRANSACTION_LIST_BY_USERID_SUCCESS: "GET_TRANSACTION_LIST_BY_USERID_SUCCESS",
  GET_TRANSACTION_LIST_BY_USERID_FAILURE: "GET_TRANSACTION_LIST_BY_USERID_FAILURE",


  GET_BUY_PKRD_HISTORY_LIST_REQUEST: "GET_BUY_PKRD_HISTORY_LIST_REQUEST",
  GET_BUY_PKRD_HISTORY_LIST_SUCCESS: "GET_BUY_PKRD_HISTORY_LIST_SUCCESS",
  GET_BUY_PKRD_HISTORY_LIST_FAILURE: "GET_BUY_PKRD_HISTORY_LIST_FAILURE",



  GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_REQUEST: "GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_REQUEST",
  GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_SUCCESS: "GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_SUCCESS",
  GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_FAILURE: "GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_FAILURE",






  GET_BANK_DETAILS_LIST_REQUEST: "GET_BANK_DETAILS_LIST_REQUEST",
  GET_BANK_DETAILS_LIST_SUCCESS: "GET_BANK_DETAILS_LIST_SUCCESS",
  GET_BANK_DETAILS_LIST_FAILURE: "GET_BANK_DETAILS_LIST_FAILURE",

  //update status
  UPDATE_USER_STATUS_REQUEST: "GET_USER_STATUS_REQUEST",
  UPDATE_USER_STATUS_SUCCESS: "GET_USER_STATUS_SUCCESS",
  UPDATE_USER_STATUS_FAILURE: "GET_USER_STATUS_FAILURE",

  //get country code list
  GET_COUNTRY_CODE_LIST_REQUEST: "GET_COUNTRY_CODE_LIST_REQUEST",
  GET_COUNTRY_CODE_LIST_SUCCESS: "GET_COUNTRY_CODE_LIST_SUCCESS",
  GET_COUNTRY_CODE_LIST_FAILURE: "GET_COUNTRY_CODE_LIST_FAILURE",

  GET_USER_BANK_DETAILS_LIST_REQUEST: "GET_USER_BANK_DETAILS_LIST_REQUEST",
  GET_USER_BANK_DETAILS_LIST_SUCCESS: "GET_USER_BANK_DETAILS_LIST_SUCCESS",
  GET_USER_BANK_DETAILS_LIST_FAILURE: "GET_USER_BANK_DETAILS_LIST_FAILURE",

  GET_REDEEM_REQUEST_LIST_REQUEST: "GET_REDEEM_REQUEST_LIST_REQUEST",
  GET_REDEEM_REQUEST_LIST_SUCCESS: "GET_REDEEM_REQUEST_LIST_SUCCESS",
  GET_REDEEM_REQUEST_LIST_FAILURE: "GET_REDEEM_REQUEST_LIST_FAILURE",


  GET_USER_DETAILS_BY_ID_REQUEST: "GET_USER_DETAILS_BY_ID_REQUEST",
  GET_USER_DETAILS_BY_ID_SUCCESS: "GET_USER_DETAILS_BY_ID_SUCCESS",
  GET_USER_DETAILS_BY_ID_FAILURE: "GET_USER_DETAILS_BY_ID_FAILURE",

  GET_MERCHANT_KYC_DETAILS_BY_ID_REQUEST: "GET_MERCHANT_KYC_DETAILS_BY_ID_REQUEST",
  GET_MERCHANT_KYC_DETAILS_BY_ID_SUCCESS: "GET_MERCHANT_KYC_DETAILS_BY_ID_SUCCESS",
  GET_MERCHANT_KYC_DETAILS_BY_ID_FAILURE: "GET_MERCHANT_KYC_DETAILS_BY_ID_FAILURE",

  GET_MERCHANT_API_KEY_LIST_REQUEST: "GET_MERCHANT_API_KEY_LIST_REQUEST",
  GET_MERCHANT_API_KEY_LIST_SUCCESS: "GET_MERCHANT_API_KEY_LIST_SUCCESS",
  GET_MERCHANT_API_KEY_LIST_FAILURE: "GET_MERCHANT_API_KEY_LIST_FAILURE",



  GET_REDEEM_REQUEST_LIST_EXPRESS_REQUEST: "GET_REDEEM_REQUEST_LIST_EXPRESS_REQUEST",
  GET_REDEEM_REQUEST_LIST_EXPRESS_SUCCESS: "GET_REDEEM_REQUEST_LIST_EXPRESS_SUCCESS",
  GET_REDEEM_REQUEST_LIST_EXPRESS_FAILURE: "GET_REDEEM_REQUEST_LIST_EXPRESS_FAILURE",








  GET_MERCHANT_WEB_STOR_CHARGE_LIST_REQUEST: "GET_MERCHANT_WEB_STOR_CHARGE_LIST_REQUEST",
  GET_MERCHANT_WEB_STOR_CHARGE_LIST_SUCCESS: "GET_MERCHANT_WEB_STOR_CHARGE_LIST_SUCCESS",
  GET_MERCHANT_WEB_STOR_CHARGE_LIST_FAILURE: "GET_MERCHANT_WEB_STOR_CHARGE_LIST_FAILURE",


};
